import React, { Component } from 'react';
import moment from 'moment';
import './DataAddition.scss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TimePicker from 'react-times';
import 'react-times/css/material/default.css';
import Select from 'react-select';
import FormElement from '../FormElement/FormElement';
import Button from '../Button/Button';
import Loader from '../Loader/Loader';
import request from '../../Ajax';
import { toast } from 'react-toastify';

export default class DataAddition extends Component {
  constructor(props) {
    super(props);
    this.inner_state = {
      urlTypes: props.lang === 1 ? 'useTypes/hy' : 'useTypes/en',
      updateContract: 'updateContractInfo',
      labels: 'getLabels',
      banks: 'banks',
    };

    let aswaSuggestedStartTime = moment(this.props.startDate).format('HH:mm');

    if (aswaSuggestedStartTime == '23:59') {
      var bestSuggestedStart = moment(this.props.startDate).add(1, 'minutes').toDate();
    } else {
      var bestSuggestedStart = moment(this.props.startDate).toDate();
    }

    this.state = {
      dateWarning: false,
      validClassName: this.props.dataState.validClassName,
      selectedUseOption: this.props.dataState.selectedUseOption,
      useTypeId: this.props.dataState.useTypeId,
      phoneNumber: this.props.dataState.phoneNumber,
      email: this.props.dataState.email ? this.props.dataState.email : '',
      bestSuggestedStart: bestSuggestedStart,
      startDate:
        this.props.dataState.startDate !== undefined
          ? new Date(this.props.dataState.startDate)
          : moment(bestSuggestedStart).toDate(),
      endDate:
        this.props.dataState.endDate !== undefined
          ? new Date(this.props.dataState.endDate)
          : moment(bestSuggestedStart).add(3, 'months').toDate(),
      time: moment(bestSuggestedStart).format('HH:mm'),
      useTypeOption: this.props.dataState.useTypeOption,
      token: this.props.token,
      isFetching: true,
      error_message: false,
      labels: {},
      banks: {},
      durations: {},
      selectedBankOption: this.props.dataState.selectedBankOption,
      accountNumber: this.props.dataState.accountNumber,
      duration: this.props.dataState.duration,
      durationAmount: this.props.dataState.durationAmount,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDurationInputChange = this.handleDurationInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleBankSelectChange = this.handleBankSelectChange.bind(this);
  }

  handleInputChange(e) {
    this.setState({
      validClassName: 'valid-element',
      [e.target.name]: e.target.value,
    });
  }

  handleDurationInputChange(e) {
    const amount = parseInt(e.target.value);
    this.setState({ durationAmount: amount }, this.handleEndDate);
  }

  handleSelectChange(selectedOption, e) {
    this.setState({
      [e.name]: selectedOption.value,
      selectedUseOption: selectedOption,
    });
  }

  handleBankSelectChange(selectedBankOption, e) {
    this.setState({ [e.name]: selectedBankOption.value, selectedBankOption });
  }

  preventNegativeInput(event) {
    if (
      (event.key === '-' || event.key === 'ArrowDown') &&
      (event.target.value.includes('-') || event.target.value === '' || event.target.value === '0')
    ) {
      event.preventDefault();
    }
  }

  error = (error_message) => {
    return error_message ? (
      <div className='column small-12'>
        <div className='date_warning'>
          <span className='custom_icon_warning'>!</span>
          <span className='date_warning_text'>{error_message}</span>
        </div>
      </div>
    ) : (
      ''
    );
  };

  durationWarning = () => {
    const { labels, durationAmount } = this.state;
    // if (selectedDurationOption !== undefined) {
    if (durationAmount < 3 || durationAmount > 12) {
      return this.error(
        durationAmount < 3 ? 'Առնվազն ժամկետը 3 ամիսն է' : 'Առավելագույն ժամկետը 12 ամիսն է'
      );
    }
    // }
    return null;
  };

  handleEndDate = () => {
    const { durationAmount, startDate, labels } = this.state;
    if (!startDate || isNaN(durationAmount)) return;

    const endDate = moment(startDate).add(durationAmount, 'month').toDate();
    this.setState({ endDate });
  };

  handleDateChange = () => {
    const diffInMonths = moment(this.state.endDate).diff(moment(this.state.startDate), 'months');
    this.setState({ durationAmount: diffInMonths });
  };

  componentDidUpdate() {
    if (Object.keys(this.state.labels).length !== 0 && this.state.isFetching === true) {
      this.setState({ isFetching: false });
    }
  }

  componentDidMount() {
    request(
      this.inner_state.labels,
      'post',
      { page_type: 'data_filling', lang: this.props.lang },
      (response) => {
        if (response.data.status === true) {
          this.setState({ labels: response.data.data });
          this.setState({
            durations: [
              { value: 'day', label: this.state.labels.day },
              { value: 'month', label: this.state.labels.month },
            ],
          });
        } else {
          //todo chgitem inch erb labelneri het kapvac xndir ka
        }
      }
    );

    request(this.inner_state.urlTypes, 'get', {}, (response) => {
      if (response.data.status === true) {
        let data = response.data.data;
        let useTypeOption = [];
        data.map((val) => {
          useTypeOption.push({
            value: val.id,
            label: val.value,
          });
        });

        this.setState({ useTypeOption: useTypeOption });
      } else {
        toast.error(response.data.message);
      }
    });

    request(this.inner_state.banks, 'get', {}, (response) => {
      if (response.data.status === true) {
        let data = response.data.data;
        let banks = [];
        data.map((val) => {
          let name = val.translations.find((lang) => {
            let currentLang = this.props.lang === 1 ? 'hy' : 'en';
            return lang['languageCode'] === currentLang;
          });
          let bank = { value: val.id, label: name.value };
          banks.push(bank);
        });

        this.setState({ banks });
      } else {
        toast.error(response.data.message);
      }
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    let state = {
      useTypeId: this.state.useTypeId,
      phoneNumber: this.state.phoneNumber,
      durationInMonths: this.state.durationAmount,
      email: this.state.email,
      startDate: this.state.startDate,
      bankAccountNumber: this.state.accountNumber,
      token: this.state.token,
      useOption: this.state.selectedUseOption,
    };

    const startDate = new Date(state.startDate);
    const endDate = new Date(this.state.endDate);

    if (
      startDate.getTime() < endDate.getTime() &&
      this.state.durationAmount >= 3 &&
      this.state.durationAmount <= 12
    ) {
      this.setState({ isFetching: true });

      state.startDate = new Date(state.startDate).getTime();

      request(this.inner_state.updateContract, 'post', state, (response) => {
        if (response.data.status === true) {
          this.props.onSubmit(state);
          this.setState({ error_message: '', isFetching: false });
        } else {
          this.setState({
            error_message: response.data.message,
            isFetching: false,
          });
          //todo: error message
        }
      });
    } else {
      this.setState({
        error_message: 'Պայմանագրի համար ընտրված ժամանակահատվածը պետք է 3 ամսից 12 ամիս լինի',
      });
    }
  };

  render() {
    return (
      <>
        <div className='column small-12'>
          <div className='top_section'>
            <div className='top_section__headline custom-headline'>
              <h2>
                {this.state.labels.title}
                {/*Տվյալների լրացում*/}
              </h2>
            </div>
            <div className='top_section__desc'>
              {this.state.labels.small_title}
              {/*Խնդրում ենք լրացնել ստորև դաշտերը*/}
            </div>
          </div>
        </div>
        <div className='column small-12 large-5'>
          {this.state.isFetching ? (
            <Loader />
          ) : (
            <form
              action=''
              onSubmit={this.handleSubmit}
            >
              <div className='row'>
                <div className='column small-12'>
                  <FormElement
                    void
                    label={this.state.labels.proposal}
                  >
                    <Select
                      value={this.state.selectedUseOption}
                      onChange={this.handleSelectChange}
                      options={this.state.useTypeOption}
                      name='useTypeId'
                      required={true}
                      placeholder={this.state.labels.select}
                    />
                  </FormElement>
                </div>

                <div className='column small-12 large-6'>
                  <FormElement
                    label={this.state.labels.phone}
                    mask='+374 (011) 111111'
                    name='phoneNumber'
                    required={true}
                    value={this.state.phoneNumber}
                    onChange={this.handleInputChange}
                  />
                </div>

                <div className='column small-12 large-6'>
                  <FormElement
                    label={this.state.labels.mail}
                    type='email'
                    name='email'
                    required={true}
                    value={this.state.email}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>

              <div className='row'>
                <div className='column small-12'>
                  <FormElement
                    label={this.state.labels.term}
                    type='number'
                    name='durationAmount'
                    required={true}
                    value={this.state.durationAmount}
                    onChange={this.handleDurationInputChange}
                    onKeyDown={this.preventNegativeInput}
                  />
                </div>
              </div>

              {this.durationWarning()}

              <div className='row'>
                <div className='column small-12 large-6'>
                  <FormElement
                    void
                    label={this.state.labels.time_start}
                  >
                    <div className='flex-container small-order-2 relative fluid-x'>
                      <div className='mr_10'>
                        <DatePicker
                          required={true}
                          selected={this.state.startDate}
                          dateFormat='d/M/yyyy'
                          onChange={(date) => {
                            let oldState = this.state.startDate;
                            this.setState({ startDate: date }, () => {
                              this.handleDateChange();
                            });
                          }}
                          minDate={moment(this.state.bestSuggestedStart).toDate()}
                        />
                      </div>

                      <TimePicker
                        required={true}
                        onFocusChange={this.onFocusChange}
                        onTimeChange={this.onTimeChange}
                        time={this.state.time}
                      />
                    </div>
                  </FormElement>
                </div>

                <div className='column small-12 large-6'>
                  <FormElement
                    void
                    label={this.state.labels.time_end}
                  >
                    <DatePicker
                      required={true}
                      selected={this.state.endDate}
                      dateFormat='d/M/yyyy'
                      minDate={moment(this.state.bestSuggestedStart).add(3, 'months').toDate()}
                      readOnly={true}
                    />
                  </FormElement>
                </div>
              </div>

              <div className='row'>
                <div className='column small-12 '>
                  <FormElement
                    label={this.state.labels.accountNumber}
                    type='number'
                    name='accountNumber'
                    required={true}
                    value={this.state.accountNumber}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              {this.error(this.state.error_message)}
              <div className='row'>
                <div className='column small-12'>
                  <div className='flex-container align-justify data_add_submit'>
                    <Button
                      inner={this.state.labels.previous}
                      onClick={() => {
                        this.props.onPrevious();
                      }}
                      classNames='icon-left'
                      icon='arrow-left'
                      iconPosition='left'
                    />

                    <Button
                      inner={this.state.labels.next}
                      classNames='btn-green icon-right'
                      type='submit'
                      icon='arrow-right'
                      iconPosition='right'
                    />
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </>
    );
  }
}
